import { useSortBy } from 'react-instantsearch';
import { FormattedMessage } from 'react-intl';

import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import { PrintablePlayerSortName } from '@sorare/core/src/contexts/config';
import { useI18nSortByItems } from '@sorare/core/src/hooks/search/useI18nSortByItems';

type Props = {
  l15Sort: PrintablePlayerSortName;
  projectedGradeSort: PrintablePlayerSortName;
  onSortChange: (sort: PrintablePlayerSortName) => void;
};

export const SortControls = ({
  l15Sort,
  projectedGradeSort,
  onSortChange,
}: Props) => {
  const sortItems = useI18nSortByItems([l15Sort, projectedGradeSort]);
  const { refine, currentRefinement } = useSortBy({
    items: sortItems,
  });

  return (
    <TabBar value={currentRefinement} variant="segmented">
      <Tab
        value="DESC-L15"
        onClick={() => {
          refine(sortItems.at(0)?.value || '');
          onSortChange(sortItems.at(0)?.value as PrintablePlayerSortName);
        }}
      >
        <FormattedMessage
          id="EditFirstLineupDialog.SortControls.l15Sort"
          defaultMessage="Top Rated"
        />
      </Tab>
      <Tab
        value="DESC-projected_grade"
        onClick={() => {
          refine(sortItems.at(1)?.value || '');
          onSortChange(sortItems.at(1)?.value as PrintablePlayerSortName);
        }}
      >
        <FormattedMessage
          id="EditFirstLineupDialog.SortControls.projectedGradeSort"
          defaultMessage="Projected Grade"
        />
      </Tab>
    </TabBar>
  );
};
